import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { api, TOKEN_KEY } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [teacher, setTeacher] = useState(null);

  useEffect(() => {
    if (!localStorage.getItem(TOKEN_KEY)) {
      setTeacher(false);
      return;
    }
    api.get("/auth/me").then((r) => setTeacher(r.data)).catch(() => setTeacher(false));
  }, []);

  const login = useCallback(async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem(TOKEN_KEY, data.token);
    setTeacher(data.teacher);
  }, []);

  const register = useCallback(async (body) => {
    const { data } = await api.post("/auth/register", body);
    localStorage.setItem(TOKEN_KEY, data.token);
    setTeacher(data.teacher);
  }, []);

  const logout = useCallback(() => {
    localStorage.removeItem(TOKEN_KEY);
    setTeacher(false);
  }, []);

  return <AuthContext.Provider value={{ teacher, login, register, logout }}>{children}</AuthContext.Provider>;
}

export const useAuth = () => useContext(AuthContext);

export function ProtectedRoute({ children }) {
  const { teacher } = useAuth();
  if (teacher === null) {
    return <div className="p-10 eyebrow" data-testid="auth-loading">Yükleniyor…</div>;
  }
  if (!teacher) return <Navigate to="/ogretmen/giris" replace />;
  return children;
}
